import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AnalyticsResultsService, DailyBalanceStatisticAll } from 'src/app/shared/services/analytics-results.service';

@Component({
  selector: 'app-daily-balance-all-accounts-line-chart',
  templateUrl: './daily-balance-all-accounts-line-chart.component.html',
  styleUrls: ['../widgets.scss', './daily-balance-all-accounts-line-chart.component.scss']
})
export class DailyBalanceAllAccountsLineChartComponent implements OnInit {
  isMobile: boolean = false;
  dailyBalanceLoading: boolean = true;
  dailyBalanceNotFound: boolean = false;
  dailyBalance: DailyBalanceStatisticAll[] = new Array<DailyBalanceStatisticAll>();
  
  constructor(private resultsAnalyticsSvc: AnalyticsResultsService, private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      if (result.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
  }

  ngOnInit(): void {
    this.resultsAnalyticsSvc.getDailyBalanceLastYear()
    .subscribe({
      next: (data: DailyBalanceStatisticAll[]) => {
        this.dailyBalance = data;
        this.dailyBalanceLoading = false;
      },
      error: (err: HttpErrorResponse) => {
        if (err.status >= 400 && err.status <= 404) {
          this.dailyBalanceNotFound = true;
          this.dailyBalanceLoading = false;
        } else {
          throw err;
        }
      }
    });
  }

}
